let userMgt = [
  {
    path: 'userMgt',
    meta: {
      title: '用户管理',
      breadcrumb: true
    },
    component: {
      name: 'userMgt',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '用户管理',
        },
        component: (resolve) => require(['@/views/plat/userCenter/userMgt'], resolve)
      }
    ]
  },
  {
    path: 'userSettle',
    meta: {
      title: '光明使者结算',
      breadcrumb: true
    },
    component: {
      name: 'userSettle',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '光明使者结算',
        },
        component: (resolve) => require(['@/views/plat/userCenter/userSettle'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: '详情',
          breadcrumb: true
        },
        component: (resolve) => require(['@/views/plat/userCenter/userSettle/detail'],resolve)
      }
    ]
  },
  {
    path: 'userExtract',
    meta: {
      title: '光明使者提现',
      breadcrumb: true
    },
    component: {
      name: 'userExtract',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '光明使者提现',
        },
        component: (resolve) => require(['@/views/plat/userCenter/userExtract'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: '详情',
          breadcrumb: true
        },
        component: (resolve) => require(['@/views/plat/userCenter/userExtract/detail'],resolve)
      }
    ]
  },
]


export default {
  path: '/userCenter',
  redirect: '/userCenter/userMgt',
  meta: {
      title: "用户中心",
      breadcrumb: true
  },
  component: {
      name: 'userCenter',
      template: '<router-view></router-view>'
  },
  children: userMgt
}


// WEBPACK FOOTER //
// ./src/router/userCenter.js